module.exports = __webpack_public_path__ + "static/Copernicus-Book-54b5810cc8ff74fd558e1b79112d0607.woff";